import { useQuery } from "@tanstack/vue-query";
import { computed } from "vue";
import { queries } from "./queries";

export function useDeepSearchAllowed() {
  const { data } = useQuery(queries.enabledForUser());
  const deepSearchAllowed = computed(() => data.value?.enabled ?? false);

  return {
    deepSearchAllowed,
  };
}
